interface LoaderProps {
  isVisible: boolean;
}

export function Loader({ isVisible }: LoaderProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-999 flex items-center justify-center bg-white/80">
      <div className="h-20 w-20 animate-spin rounded-full border-[6px] border-gray-200 border-t-gray-800" />
    </div>
  );
}
